import React from 'react';
import { render } from 'react-dom';
import Directory from './Components/Directory';
import SpecialDirectoryEntry from './Components/SpecialDirectoryEntry';
import ReplacableSelect from './Components/ReplacableSelect';

let directoryElement = document.getElementById('directory');
if (directoryElement) {
    render(<Directory />, directoryElement);
}

let selects = document.getElementsByClassName('chosen');
if (selects) {
    for (let element of selects) {
        if (element.tagName.toString() !== 'DIV') continue;

        let options = Array.from(element.getElementsByTagName('option'));
        let id = element.getElementsByTagName('select')[0].id;
        let name = element.getElementsByTagName('select')[0].name;
        let label = element.getElementsByTagName('label')[0].innerHTML;
        render(<ReplacableSelect options={ options } name={ name } id={ id } label={ label } />, element);
    }
}

let individualElements = document.getElementsByClassName('special-directory');
for (let element of individualElements) {
    render(<Directory hideFilter={ true } openDirectoryItem={ false } />, element);
}
